import {
  Award,
  Brain,
  Camera,
  Coffee,
  Compass,
  Flag,
  Flame,
  Gem,
  Gift,
  GraduationCap,
  Handshake,
  Key,
  Lightbulb,
  Map as MapIcon,
  MapPin,
  MessageCircle,
  Mic,
  Music,
  Puzzle,
  Rocket,
  Star,
  Target,
  Telescope,
  Trophy,
  Users,
  Zap,
  type LucideIcon,
} from 'lucide-react';

/**
 * Curated quest-group icon set (docs/07 addendum): Lucide names an admin can
 * pick in the group dialog (8 per row grid). Stored on quest_groups.icon as
 * the kebab-case name; `groupIcon()` resolves unknown names to the fallback
 * so stale data never crashes a client.
 */
export const GROUP_ICONS: ReadonlyArray<{ name: string; Icon: LucideIcon }> = [
  { name: 'star', Icon: Star },
  { name: 'compass', Icon: Compass },
  { name: 'map-pin', Icon: MapPin },
  { name: 'trophy', Icon: Trophy },
  { name: 'brain', Icon: Brain },
  { name: 'camera', Icon: Camera },
  { name: 'handshake', Icon: Handshake },
  { name: 'zap', Icon: Zap },
  { name: 'map', Icon: MapIcon },
  { name: 'target', Icon: Target },
  { name: 'telescope', Icon: Telescope },
  { name: 'puzzle', Icon: Puzzle },
  { name: 'rocket', Icon: Rocket },
  { name: 'message-circle', Icon: MessageCircle },
  { name: 'graduation-cap', Icon: GraduationCap },
  { name: 'key', Icon: Key },
  { name: 'users', Icon: Users },
  { name: 'lightbulb', Icon: Lightbulb },
  { name: 'flame', Icon: Flame },
  { name: 'flag', Icon: Flag },
  { name: 'award', Icon: Award },
  { name: 'gem', Icon: Gem },
  { name: 'gift', Icon: Gift },
  { name: 'mic', Icon: Mic },
  { name: 'music', Icon: Music },
  { name: 'coffee', Icon: Coffee },
] as const;

export const GROUP_ICON_NAMES: readonly string[] = GROUP_ICONS.map((entry) => entry.name);

const BY_NAME = new globalThis.Map<string, LucideIcon>(
  GROUP_ICONS.map((entry) => [entry.name, entry.Icon]),
);

export const DEFAULT_GROUP_ICON = 'star';

/** Resolve a stored icon name; unknown names fall back to the star. */
export function groupIcon(name: string): LucideIcon {
  return BY_NAME.get(name) ?? Star;
}
